import { motion } from "framer-motion";
import { useEffect, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const sectionFade = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function PrivacyPolicy() {
  const { t, isRTL } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sections = t("privacy.sections", { returnObjects: true });

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-gradient-to-b from-rose-50/50 via-white to-white py-24">
      <div className="mx-auto max-w-4xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-20 text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold">
            {t("privacy.title")}
          </h1>
          <p className="mt-4 text-gray-600">
            {t("privacy.lastReviewed")}: {new Date().getFullYear()}
          </p>
        </motion.div>

        {/* Content */}
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          {sections.map((section, i) => (
            <motion.div key={i} variants={sectionFade} className="mb-8 rounded-2xl border bg-white p-8 shadow-sm">
              <h2 className="mb-4 text-xl font-semibold border-l-4 border-rose-600 pl-4">
                {section.title}
              </h2>

              {section.paragraphs?.map((p, idx) => (
                <p key={idx} className="mb-3 text-gray-700">{p}</p>
              ))}

              {section.blocks?.map((b, idx) => (
                <div key={idx} className="mb-4">
                  <p className="font-semibold">{b.title}</p>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    {b.list.map((li, j) => <li key={j}>{li}</li>)}
                  </ul>
                </div>
              ))}

              {section.list && (
                <ul className="list-disc pl-6 space-y-2">
                  {section.list.map((li, j) => <li key={j}>{li}</li>)}
                </ul>
              )}

              {section.note && (
                <div className="mt-4 rounded-xl bg-rose-50 border border-rose-200 p-4 text-sm">
                  {section.note}
                </div>
              )}

              {section.disclaimer && (
                <p className="mt-4 text-sm text-gray-500">
                  {section.disclaimer}
                </p>
              )}
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}
